module.exports = __webpack_public_path__ + "img/handmade-character.a3a225a9.svg";